import { useMutation, useQueryClient } from 'react-query';

import uiNotificationService from 'services/uiNotification.service';

import userService from 'resources/user/user.service';

export default function useAddNewClient() {
  const queryClient = useQueryClient();

  return useMutation(
    (requestData) => userService.createClient(requestData),
    {
      onSuccess: async (user) => {
        if (!user || user.isBadRequest) {
          uiNotificationService.showError('Sorry, something went wrong. Please refresh this page or try again later.');
          return;
        }

        uiNotificationService.showSuccess('The client was successfully added');

        queryClient.invalidateQueries(['users.getCompanyClients', user.company_id]);
        queryClient.invalidateQueries(['users.companyUsers', user.company_id]);

        // Get the realtors to get the team and invalidate get clients by team query
        await Promise.all(user.realtor_ids.map(async (realtorId) => {
          const realtor = await userService.getUserById(realtorId);
          if (realtor?.team_id) {
            queryClient.invalidateQueries(['users.getClientsByTeam', realtor.team_id]);
          }
        }));
      },
      onError: () => {
        uiNotificationService.showError('Sorry, something went wrong. Please refresh this page or try again later.');
      },
    },
  );
}
